import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { cdnAssetUrl } from "../../config/staticAssets";
import { DOWNLOAD_LINKS, FEATURE_CARDS, STORE_BADGES } from "./downloadAppContent";

function ServiceCard({ item }) {
  return (
    <article className="wlj-about-service-card">
      <div className="wlj-about-service-card-inner">
        <div className="wlj-about-service-card-icon">
          <img src={item.icon} alt="" />
        </div>
        <h3>{item.title}</h3>
        <p>{item.text}</p>
        <div className="wlj-about-service-card-shape" aria-hidden="true">
          <img src={cdnAssetUrl("assets/img/shape/srv_shape.png")} alt="" />
        </div>
        <span className="wlj-about-service-card-overlay" aria-hidden="true" />
      </div>
    </article>
  );
}

function DownloadAppBody() {
  return (
    <>
      <div className="wlj-download-body">
        <section className="wlj-download-hero">
          <div className="wlj-container">
            <h2 className="wlj-download-hero-title">Download Welinkjobs App</h2>
            <div className="wlj-download-hero-grid">
              <div className="wlj-download-stores">
                <div className="wlj-download-divider">Download Android Mobile App</div>
                <div className="wlj-download-store-row">
                  <a
                    href={DOWNLOAD_LINKS.android}
                    className="wlj-download-store-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="wlj-download-store-badge wlj-download-store-badge--google"
                      src={STORE_BADGES.googlePlay}
                      alt="Get it on Google Play"
                    />
                  </a>
                  <img className="wlj-download-qr" src={DOWNLOAD_LINKS.androidQr} alt="Android app QR code" />
                </div>

                <div className="wlj-download-divider">Download IOS Mobile App</div>
                <div className="wlj-download-store-row">
                  <a
                    href={DOWNLOAD_LINKS.ios}
                    className="wlj-download-store-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="wlj-download-store-badge wlj-download-store-badge--apple"
                      src={STORE_BADGES.appStore}
                      alt="Download on the App Store"
                    />
                  </a>
                  <img className="wlj-download-qr" src={DOWNLOAD_LINKS.iosQr} alt="iOS app QR code" />
                </div>
              </div>

              <div className="wlj-download-hero-media">
                <div className="wlj-download-hero-video-wrap">
                  <video autoPlay muted playsInline controls>
                    <source src={DOWNLOAD_LINKS.introVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wlj-download-mockup">
          <div className="wlj-container">
            <div className="wlj-download-mockup-grid">
              <div className="wlj-download-mockup-image">
                <img src={cdnAssetUrl("assets/img/about/mockup.png")} alt="Welinkjobs app mockup" />
              </div>
              <div className="wlj-download-mockup-copy">
                <h1 className="wlj-download-section-title">Search And Apply For Jobs Globally</h1>
                <p>
                  The app offers a wide range of international career opportunities and connects candidates
                  with potential recruiters. You can easily browse vacancies and find a career network to help
                  you land your next great job.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="wlj-about-fanfact" aria-label="App preview video">
        <div className="wlj-about-fanfact-media">
          <video
            className="wlj-about-fanfact-video"
            src={cdnAssetUrl("assets/img/about/newabout.mp4")}
            loop
            autoPlay
            muted
            playsInline
          />
        </div>
      </section>

      <section className="wlj-about-hotline" aria-label="Contact hotline">
        <div className="wlj-container">
          <div className="wlj-about-hotline-inner">
            <div className="wlj-about-hotline-phone">
              <a href={DOWNLOAD_LINKS.hotlinePhone} className="wlj-about-hotline-icon" aria-label="Phone">
                <FontAwesomeIcon icon={faPhone} />
              </a>
              <h3 className="wlj-about-hotline-number">{DOWNLOAD_LINKS.hotlineDisplay}</h3>
            </div>
            <div className="wlj-about-hotline-whatsapp">
              <p className="wlj-about-hotline-text">
                Use our Hotline for quick get <br />
                in touch for 24 hours
              </p>
              <a
                href={DOWNLOAD_LINKS.whatsapp}
                target="_blank"
                rel="noreferrer"
                className="wlj-about-hotline-icon"
                aria-label="WhatsApp"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="wlj-about-services wlj-download-services">
        <div className="wlj-container">
          <h1 className="wlj-download-features-title">Welinkjobs Features</h1>
          <div className="wlj-about-services-grid">
            <div className="wlj-about-services-col">
              <div className="wlj-about-service-lead">
                <h4>Job Search and Application:</h4>
                <p>
                  Users can search for and apply to job opportunities globally through an interactive
                  platform
                </p>
              </div>
              <div className="wlj-about-service-photo">
                <img
                  src={cdnAssetUrl(
                    "assets/imagesforportal/complexities-hrm-through-compelling-graphic-featuring-magnifier-glass-zooming-man.jpg",
                  )}
                  alt="Job search and application"
                />
              </div>
              <ServiceCard item={FEATURE_CARDS[4]} />
            </div>

            <div className="wlj-about-services-col">
              <ServiceCard item={FEATURE_CARDS[0]} />
              <ServiceCard item={FEATURE_CARDS[1]} />
              <ServiceCard item={FEATURE_CARDS[5]} />
            </div>

            <div className="wlj-about-services-col">
              <ServiceCard item={FEATURE_CARDS[2]} />
              <ServiceCard item={FEATURE_CARDS[3]} />
            </div>
          </div>
        </div>
        <div className="wlj-about-services-shape wlj-about-services-shape--1" aria-hidden="true">
          <img src={cdnAssetUrl("assets/img/shape/srv_shape1.png")} alt="" />
        </div>
        <div className="wlj-about-services-shape wlj-about-services-shape--2" aria-hidden="true">
          <img src={cdnAssetUrl("assets/img/shape/srv_shape2.png")} alt="" />
        </div>
      </section>
    </>
  );
}

export default DownloadAppBody;
